import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseConversationJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|conversationId|bindingId|memberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseConversationJson] };

/** Journey Chat binding only. Messages stay on IM. */
export const journeyConversationApi = {
  get: (journeyId) => travelClient.get(travelEndpoints.journeyConversation(journeyId), snowflakeJson),
  ensure: (journeyId) => travelClient.post(
    travelEndpoints.journeyConversation(journeyId),
    { confirm: true },
    snowflakeJson,
  ),
};
